import { useMutation } from "@apollo/client";
import {
  Button,
  Center,
  DrawerFooter,
  Spinner,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import { set } from "lodash";
import DrawerWrapper from "../../../drawers/DrawerWrapper";
import CreateMassCommodityForm from "./CreateMassCommodityForm";
import { CREATE_COMMODITIES } from "./mutations";

type Props = {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  refetch?: any;
};

const CreateMassCommodity = (props: Props) => {
  const { isOpen, onClose, refetch } = props;
  const toast = useToast();
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const [createCommodity, { loading: Creating }] =
    useMutation(CREATE_COMMODITIES);

  const onSubmit = (values: any) => {
    const inputs = values.commodities.map((value: any) => {
      const { retail, wholeSale } = value;

      if (retail) {
        set(value, "retail", Number(retail));
      }

      if (wholeSale) {
        set(value, "wholeSale", Number(wholeSale));
      }

      return {
        ...value,
        useCurrentLocation: true,
      };
    });
    return createCommodity({
      variables: { inputs },
    })
      .then((data: any) => {
        if (data) {
          onClose();
          refetch && refetch();
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: `Commodities successfully created`,
              status: "success",
              duration: 3000,
              isClosable: true,
              variant: "solid",
            });
          }
        }
      })
      .catch((error) => {
        if (!toast.isActive("active-toast")) {
          toast({
            id: "active-toast",
            title: error.message,
            description: "Please, try again.",
            status: "error",
            duration: 2000,
            isClosable: true,
            variant: "solid",
          });
        }
      });
  };

  const formName = "createMassCommodityform";
  return (
    <DrawerWrapper
      onClose={onClose}
      isOpen={isOpen}
      title="Commodities | Create"
      size="xl"
      placement="bottom"
    >
      {Creating ? (
        <Center py="5">
          <Spinner />
        </Center>
      ) : (
        <CreateMassCommodityForm
          onSubmit={onSubmit}
          formName={formName}
          initialValues={{
            commodities: [{}],
          }}
        />
      )}

      <DrawerFooter>
        <Button mr="3" w={isLargerThan900 ? "50" : "full"} onClick={onClose}>
          Cancel
        </Button>
        <Button
          w={isLargerThan900 ? "50" : "full"}
          form={formName}
          colorScheme="whatsapp"
          type="submit"
          isLoading={Creating}
          isDisabled={Creating}
        >
          Create
        </Button>
      </DrawerFooter>
    </DrawerWrapper>
  );
};

export default CreateMassCommodity;
